export default __webpack_public_path__ + "static/media/cmu-wordmark-horizontal-70k.3e394936.png";